import React from "react";
import { zl, zaokr } from "../../../functions/utilities.js";

const MieszkaniecDaneWodaRozliczenieStawki = props => {
    
    const { rozliczenieWodyAkt } = props;

    return (
        <div className="lewa">
            <table className="tabela">
                <thead>
                    <tr>
                        <th colSpan={2}>
                            Koszt jednostkowy
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>
                            zimna woda
                        </td>
                        <td className="kwoty">  
                            {zl(rozliczenieWodyAkt?.metr_3_zimnej)}
                        </td>                    
                    </tr>
                    <tr>
                        <td>
                            abonament cw
                        </td>
                        <td className="kwoty">  
                            {zl(rozliczenieWodyAkt?.abonament_msc)}
                        </td>   
                    </tr> 
                    <tr>                
                        <td>
                            ciepła woda
                        </td>
                        <td className="kwoty">  
                            {zl(rozliczenieWodyAkt?.kosztPodgrzaniaCieplej)}
                        </td>  
                    </tr>
                </tbody>
            </table>
        </div>
    )
}

export default MieszkaniecDaneWodaRozliczenieStawki;